import PropTypes from 'prop-types'

import { Dialog, Text } from '@loadsmart/miranda-react'
import { toCapitalizeFirstLetter } from '@loadsmart/utils-string'

import { ErrorIcon } from './BidDialog.styles'

function BidEntityTaken({ entity, handleClose }) {
  return (
    <>
      <Dialog.Header>
        {toCapitalizeFirstLetter(entity)} Taken
        <Dialog.Close onClick={handleClose} />
      </Dialog.Header>
      <Dialog.Body>
        <Text>
          <ErrorIcon />
          <p>
            <strong>This {entity.toLowerCase()} is no longer available</strong>
          </p>
        </Text>
      </Dialog.Body>
    </>
  )
}

BidEntityTaken.propTypes = {
  entity: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export { BidEntityTaken }
